export const camelCaseToSpaces = (str: string) => {
  return (
    str
      // insert a space before all caps
      .replace(/([A-Z])/g, " $1")
      // uppercase the first character
      .replace(/^./, function (str) {
        return str.toUpperCase();
      })
  );
};

// Copied from Ascend
export const NOT_ALPHANUMERIC_SPACE_OR_DASH = /[^a-zA-Z0-9 -]/g;
export const SPACE = /\s+/g;

export const slugify = (str: string) => {
  return str
    .replace(NOT_ALPHANUMERIC_SPACE_OR_DASH, "")
    .replace(SPACE, "-")
    .toLowerCase();
};
